// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3w-2";
export var blackBorderOnHover = "_3w-7";
export var cell = "_3w-6";
export var cellContainer = "_3w-3";
export var checked = "_3w-8";
export var disabled = "_3w-5";
export var featuredIconCellContainer = "_3w-9";
export var featuredIconTextContainer = "_3w-b";
export var featuredIconWrapper = "_3w-a";
export var noBorder = "_3w-c";
export var orangeSelectedRow = "_8w-3";
export var overflowableText = "_3w-0";
export var overflowableTextContainer = "_3w-1";
export var row = "_3y-0";
export var rowCheckboxCell = "_3w-4";
export var selectableTable = "_8w-2";